<template>
  <el-container>
    <div class="g-aside-main">
      <el-form :inline="true" @submit.native.prevent>
        <el-row type="flex">
           <el-col style="text-align: left">
            <el-button @click="goBack"> 返回 </el-button>
          </el-col>
          <el-col style="text-align: right">
            <el-form-item label="选择考试">
              <ksList
                :value.sync="ksObj"
                :ksid.sync="ksid"
                @change="query()"
              ></ksList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px" v-if="ksObj">
          <el-col :span="6"> 考试名称：{{ ksObj.ksmc }} </el-col>
          <el-col :span="6"> 考试时间：{{ ksObj.djsj }} 分钟 </el-col>
          <el-col :span="6"> 试卷总分：{{ ksObj.zf }} 分 </el-col>
          <el-col :span="6"> 及格分： {{ ksObj.jgfs }} 分 </el-col>
        </el-row>
      </el-form>
      <el-row style="margin-bottom: 10px">
        <el-col> 试题分类统计 </el-col>
      </el-row>
      <div class="yun-shadow">
        <el-table :data="tableData" style="width: 100%" :border="true">
          <el-table-column
            label="试题分类"
            width="120"
            prop="stflmc"
            align="center"
          />
          <el-table-column
            label="题目数"
            width="60"
            prop="tms"
            align="center"
          />
          <el-table-column
            label="分类总分"
            width="80"
            prop="flzf"
            align="center"
          />
          <el-table-column
            label="数量占比(%)"
            width="100"
            prop="slzb"
            align="center"
          />
          <el-table-column
            label="分数占比(%)"
            width="100"
            prop="fszb"
            align="center"
          />
          <el-table-column
            label="答题总次数"
            width="90"
            prop="dtzcs"
            align="center"
          />
          <el-table-column
            label="错误次数"
            width="80"
            prop="cwcs"
            align="center"
          />
          <el-table-column
            label="正确次数"
            width="80"
            prop="zqcs"
            align="center"
          />
          <el-table-column
            label="错误率(%)"
            width="80"
            prop="cwl"
            align="center"
          />
          <el-table-column
            label="正确率(%)"
            width="80"
            prop="zql"
            align="center"
          />
          <el-table-column
            label="平均分"
            width="80"
            prop="pjf"
            align="center"
          />
          <el-table-column
            label="得分率(%)"
            width="80"
            prop="dfl"
            align="center"
          />
        </el-table>
      </div>
      <el-row v-if="tableData && tableData.length > 0" type="flex">
        <el-col>
          <div
            id="pie"
            style="
              display: inline-block;
              width: 350px;
              height: 350px;
              margin: 20px auto 0;
            "
          ></div>
        </el-col>
        <el-col>
          <ve-histogram
            :data="chartData"
            :settings="chartSettings"
            style="
              display: inline-block;
              width: 350px;
              height: 350px;
              margin: 20px auto 0;
            "
          ></ve-histogram>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px; margin-bottom: 10px">
        试题分析（正确率排序）
      </el-row>
      <div class="yun-shadow">
        <el-table :data="tableDataStfx" style="width: 100%" :border="true">
          <el-table-column
            label="排序序号"
            width="80"
            prop="pm"
            align="center"
          />
          <el-table-column
            label="大题名称"
            width="80"
            prop="dtmc"
            align="center"
          />
          <el-table-column
            label="大题题型"
            width="80"
            prop="dttx"
            align="center"
          />
          <el-table-column
            label="试题内容"
            width="400"
            prop="stnr"
            align="left"
          >
            <template slot-scope="scope">
              <a href="#" @click="showDialog(scope.row)" style="color: blue">{{
                scope.row.stnr
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            label="错误次数"
            width="80"
            prop="cwcs"
            align="center"
          />
          <el-table-column
            label="正确次数"
            width="80"
            prop="zqcs"
            align="center"
          />
          <el-table-column
            label="正确率(%)"
            width="80"
            prop="zql"
            align="center"
          />
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="题目分析"
      :visible.sync="dialog"
      :modal-append-to-body="false"
      width="800px"
    >
      <stPage :stObj="stObj"></stPage>
    </el-dialog>
  </el-container>
</template>
<script>
import * as report from '@/api/report'
import ksList from '@/components/select/ksList'
import stPage from '@/views/report/stPage.vue'
import VCharts from 'v-charts'
import echarts from 'echarts'
import Vue from 'vue'
Vue.use(VCharts)
export default {
  data () {
    this.option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 0,
        top: 0,
        data: []
      },
      series: [
        {
          name: '分数占比',
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '30%'],
          label: {
            position: 'inner'
          },
          data: []
        },
        {
          name: '数量占比',
          type: 'pie',
          radius: ['40%', '55%'],
          data: []
        }
      ]
    }
    return {
      ksid: Number(this.$route.query.ksid),
      ksObj: {},
      tableData: [],
      tableDataStfx: [],
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,

      chartSettings: {
        showLine: ['得分率']
      },
      chartData: {
        columns: ['stflmc', '正确率', '得分率'],
        rows: []
      },

      dialog: false,
      stObj: {}
    }
  },
  components: {
    ksList,
    stPage
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/exam/list'
      })
    },
    showDialog (row) {
      this.dialog = true
      this.$set(this.stObj, 'ksid', this.ksObj.ksid)
      this.$set(this.stObj, 'sjid', row.sjid)
      this.$set(this.stObj, 'stid', row.stid)
      this.$set(this.stObj, 'zjfs', this.ksObj.zjfs)
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.queryStfxList(this.currentPage)
    },
    handleCurrentChange (val) {
      this.queryStfxList(val)
    },
    // 获取试题分析列表
    queryStfxList (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign(
        { pageNo: this.currentPage, pageSize: this.pageSize },
        {}
      )
      params.ksid = this.ksObj.ksid
      params.zjfs = this.ksObj.zjfs
      report.stfxPage(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableDataStfx = data.list
          this.totalNum = data.count
        })
      })
    },
    // 获取试题分类信息
    query () {
      const params = {}
      params.ksid = this.ksObj.ksid
      params.zjfs = this.ksObj.zjfs
      report.stflList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data
          this.legendChange(data)
          this.$nextTick(() => {
            this.initPie(data)
          })
        })
      })
      this.queryStfxList()
    },
    legendChange (data) {
      this.chartData.rows = data
      this.chartData.rows.forEach(ele => {
        ele.得分率 = ele.dfl
        ele.正确率 = ele.zql
      })
    },
    initPie (data) {
      // 初始化echarts实例
      var myChart = echarts.init(document.getElementById('pie'))
      // 刷新数据
      this.option.legend.data = data.map(data => data.stflmc)
      this.option.series[0].data = data.map(data => {
        return { name: data.stflmc, value: data.fszb }
      })
      this.option.series[1].data = data.map(data => {
        return { name: data.stflmc, value: data.slzb }
      })
      // console.log(this.option)
      myChart.setOption(this.option)
    }
  }
}
</script>
